import styled from 'styled-components';

const CardTitle = styled.h5`
  margin: 0;
  color: ${({ theme }) => theme.colors.brand || 'rgba(130, 22, 146, 1)'};
  font-weight: bold;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile || '768px'}) {
    font-size: ${({ theme }) => theme.fontSizes.medium || '1rem'};
  }
`;

export default CardTitle;
